module.exports = __webpack_public_path__ + "img/特徴-03.a3290bc6.png";